import { render, staticRenderFns } from "./modal-2.vue?vue&type=template&id=5cb46813&scoped=true"
import script from "./modal-2.vue?vue&type=script&lang=js"
export * from "./modal-2.vue?vue&type=script&lang=js"
import style0 from "./modal-2.vue?vue&type=style&index=0&id=5cb46813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb46813",
  null
  
)

export default component.exports